import { MainSectionStyles } from '../../styles/styles';

const MainSection = () => {
  return (
    <MainSectionStyles data-scroll-section className="main">
      <div data-scroll data-scroll-speed="6" className="main-pic"></div>
      <div className="main-text">
        <p>
          I spend my days tapping on keyboards and Googling stuff. I'm a skilled
          software developer with experience in JavaScript and TypeScript, and
          expertise in frameworks like React and Next.js, Node.js, and Ruby on
          Rails. I'm a quick learner and I can help you build a product, feature
          or app. If you have a project you need coded, don't hesitate to
          contact me. Let's work together to bring your ideas to life!
        </p>
      </div>
    </MainSectionStyles>
  );
};

export default MainSection;
